import React, {Component} from 'react';
import {Grid, Button, FormGroup, FormControl} from 'react-bootstrap';
import './Contact.css';


export default class Contact extends Component {

    render() {
        return (
            <Grid>
                <p>
                    Görüş ve önerilerinizi bizimle paylaşabilirisiniz:  <a>otag@anadolu.edu.tr</a>
                </p>
            </Grid>

        )
    }

}





// WEBPACK FOOTER //
// ./src/components/Contact.js